export const offer = {
  firstOrder: '10% off on your first order',
};

export const ie = {
  disclaimer: 'Unfortunately your browser is not supported.',
  recommendation: 'Please use instead Google Chrome, Mozilla Firefox or Microsoft Edge.',
};

export const cms = {
  dynPageError: 'This dynamic content is currently not available.',
  formThankYou: 'Thank you!',
  recaptchaError: 'Please confirm you are human.',
  contact: {
    phonePrefix: 'T:',
    faxPrefix: 'F:',
  },
  event: {
    today: 'Today!',
    thisWeek: 'This week!',
    nextWeek: 'Next week',
  },
};

export const cookie = {
  infoText: 'We use cookies on our website in order to tailor your shopping experience in the best possible way. ' +
    'By clicking on the button or by continuing to navigate on this website, you consent to the use of cookies.',
};
